<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import dealerImage from './images/LP-Dealer-Program-Contractor-Discount-image-1.jpg';
	import dealerCommercialImage from './images/NYC-Alma-install-Presha-Windows-03-28-19.jpg';
</script>

<Section>
	<p>
		The Indow Contractor Discount Program is designed for companies that want to
		offer Indow inserts on a one-off basis to customers without the need to meet
		minimum sales targets or make investments in Indow-specific tools. You will
		be assigned a personal Fit Specialist that can guide you through project
		assessment, pricing, and process as you bring comfort and quiet to your
		existing customers.
	</p>
	<p>
		The Indow Contractor Discount Program is a great way to help improve the
		lives of your customers. If you have an existing home performance, products,
		or construction company and want to extend the value you can bring to
		clients, our team will support you.
	</p>
	<Image
		src={dealerImage}
		alt="member of contractor discount program installs window insert"
	/>
	<h2>Your Role</h2>
	<p>
		As an approved member of our Contractor Discount Program you will work hand
		in hand with your Indow Fit Specialist to bring premium window solutions to
		your customers. We will support you by helping to assess the windows, the
		use case, and pricing to ensure your customers are well taken care of. You
		will be able to provide onsite measure and installation support making the
		entire process white-glove for your clients.
	</p>
	<h2>The Goal</h2>
	<p>
		The Contractor Discount Program makes it easy for companies that may perform
		a small number of annual projects to offer a premier window insulation
		solution to customers. If you have a single project or multiple
		opportunities, we can work with you!
	</p>
	<p>
		One of the biggest benefits of selling Indow inserts: it’s low risk. There
		is no inventory to carry. Installing the inserts is quick, without the need
		for tools or a mounting bracket, and it’s easy to do large-scale projects.
	</p>
	<p>
		Indow inserts are as simple to promote as they are to install—award-winning,
		US-made, and with performance data backed by independent, third-party
		testing.
	</p>
	<h2>Eligibility</h2>
	<p>
		In order to qualify for the Contractor Discount Program you must be able to
		provide the following documentation:
	</p>
	<ul class="mb-8">
		<li>
			A Certificate of Insurance/Liability with the following:
			<ul class="pt-2">
				<li>
					<p>
						Coverage on an "occurrence" rather than on a "claims made" basis
					</p>
				</li>
				<li>
					<p>
						Combined general liability policy & product liability limit of at
						least $1,000,000 each occurrence, and if applicable, $2,000,000
						aggregate
					</p>
				</li>
				<li>
					<p>
						Naming of R Value, Inc. dba Indow, 6427 NE 59th Pl, Portland, OR
						97218 as an additional insured certificate holder
					</p>
				</li>
			</ul>
		</li>
		<li>A resale certificate</li>
		<li>
			A digital signature on our <a
				href="https://indowwindows.com/contractor-agreement"
				>contractor agreement.</a
			>
		</li>
	</ul>
	<p>
		Fill out our Free Estimate form and one of our Fit Specialists will help
		guide you through the process and help you determine if you qualify. Let us
		know you’re interested in the Contractor Discount Program in the “How can we
		help you?” section.
	</p>
	<p>
		Beyond these benefits, Indow allows you to become a trusted advisor in the
		window space by offering a solution no one else can.
	</p>

	<p>
		If you have a larger team or multiple business locations, we can discuss how
		to better work with scaling your business in a deeper relationship. Fill out
		the form and we will work with you to create a custom arrangement.
	</p>
	<Image
		src={dealerCommercialImage}
		alt="member of contractor discount program installs window insert"
	/>
	<p>
		To see if this unique product will be a fit for your business, fill out the
		form below.
	</p>
</Section>
<GetAFreeEstimate />
